// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xAvk","label":"styles_label__34SNc"};